// ============================================
// NETWORK CONFIGURATION - CHANGE HERE
// ============================================
export const ACTIVE_NETWORK = 'mainnet';

// ============================================
// NETWORK DETAILS
// ============================================
export const NETWORKS = {
  mainnet: {
    chainId: 56,
    chainIdHex: '0x38',
    chainName: 'BNB Smart Chain',
    nativeCurrency: {
      name: 'BNB',
      symbol: 'BNB',
      decimals: 18
    },
    rpcUrls: ['https://bsc-dataseed1.binance.org/'],
    blockExplorerUrls: ['https://bscscan.com/']
  },
  testnet: {
    chainId: 97,
    chainIdHex: '0x61',
    chainName: 'BNB Smart Chain',
    nativeCurrency: {
      name: 'tBNB',
      symbol: 'tBNB',
      decimals: 18
    },
    rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
    blockExplorerUrls: ['https://testnet.bscscan.com/']
  }
};

// ============================================
// CONTRACT ADDRESSES - UPDATE THESE
// ============================================
export const CONTRACTS = {
  mainnet: {
    headOrTails: '0x1E93d277F3D3Abe7099863843d68aD58f1CbC95c',
    usdt: '0x55d398326f99059fF775485246999027B3197955'
  },
  testnet: {
    headOrTails: '0x2afc812Ca48E65Fd5968F4dee0A47FbE08c7e5c0',
    usdt: '0x2620D043772DdE2a4B5cfBB807Aa3ebd678DD1DC'
  }
};

export const getNetworkConfig = () => NETWORKS[ACTIVE_NETWORK];
export const getContracts = () => CONTRACTS[ACTIVE_NETWORK];

// ============================================
// CONTRACT ABI
// ============================================
export const HEAD_OR_TAILS_ABI = [
  "event UserRegistered(address indexed user)",
  "event InvestmentMade(address indexed user, uint256 amount, uint8 room, uint256 cycle)",
  "event CycleCompleted(uint256 cycle, uint8 winningRoom, uint256 winningPoolAmount, uint256 toReserve)",
  "event Withdrawal(address indexed user, uint256 amount, uint256 fee)",
  
  "function isUserRegistered(address _user) external view returns (bool)",
  "function getUserInfo(address _user) external view returns (uint256 totalInvested, uint256 claimableWinnings, uint256 totalWithdrawn)",
  "function getCycleInfo(uint256 _cycle) external view returns (uint256 headPool, uint256 tailPool, uint256 activeUserCount, bool completed, uint8 winningRoom, uint256 totalInvested)",
  "function getCurrentCycleTimeLeft() external view returns (uint256)",
  "function getLastWinningRoom() external view returns (uint8 winningRoom, uint256 cycle)",
  "function getContractBalance() external view returns (uint256)",
  "function getContractPools() external view returns (uint256 router, uint256 reserve, uint256 userClaimable)",
  "function getContractStats() external view returns (uint256 _totalUsers, uint256 _currentCycle, uint256 _cycleDuration)",
  "function isUserActiveInCurrentCycle(address _user) external view returns (bool)",
  "function getRoomInvestorCount(uint256 _cycle, uint8 _room) external view returns (uint256)",
  "function getUserInvestments(address _user, uint256 _start, uint256 _limit) external view returns (uint256[] memory amounts, uint8[] memory rooms, uint256[] memory cycleNums, uint256[] memory timestamps)",
  "function currentCycle() external view returns (uint256)",
  "function cycleDuration() external view returns (uint256)",
  "function minInvestment() external view returns (uint256)",
  "function maxInvestment() external view returns (uint256)",
  
  "function register() external",
  "function invest(uint256 _amount, uint8 _room) external",
  "function withdraw(uint256 _amount) external"
];

export const ERC20_ABI = [
  "function balanceOf(address owner) view returns (uint256)",
  "function decimals() view returns (uint8)",
  "function symbol() view returns (string)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function allowance(address owner, address spender) view returns (uint256)"
];
